export default function(apiKey, user) {
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
        v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
            o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');

    // Call this whenever information about your visitors becomes available
    // Please use Strings, Numbers, or Bools for value types.
    pendo.initialize({
        visitor: {
            id: user.info.master_user_id,
            type_id: user.info.type_id,
            role_id: user.info.role_id,
            created_at: user.info.created_at,
            timezone_name: user.info.master_timezone_name,
            user_sku: user.info.user_sku,
        },

        account: {
            id: user.info.org_id,
            name: user.info.org_name,
        }
    });
};
